import React from 'react';
import cx from 'classnames';
import { validatePhoneNumber, statuses } from './utils';
import { Actions } from './reducer';
import classes from './styles.scss';


const getContainerClasses = (staticRender) => {
  return cx({
    'row-fluid': true,
    [classes.textAppContainer]: true,
    [classes.clientNotReady]: staticRender,
  });
};


const getPhoneNumberClass = (inputValue, status, isValid) => {
  return cx({
    [classes.phoneNumberInitial]: true,
    [classes.phoneNumberError]: !isValid && inputValue && status === statuses.INITIAL,
    [classes.phoneNumberSuccess]: isValid && inputValue && status === statuses.INITIAL,
  });
};


const getInputDisabled = (status, staticRender = false) => {
  return staticRender || (status !== statuses.INITIAL);
};


const getButtonDisabled = (inputValue, status, isValid) => {
  return !isValid || !inputValue || status !== statuses.INITIAL;
};


const onInputKeyUp = (dispatch, isValid) => (ev) => {
  // user hit enter
  if(ev.which === 13 && isValid) {
    dispatch(Actions.sendSmsStart());
    return;
  }

  dispatch(Actions.updateInputValue(ev.target.value));
};


const onButtonClick = (dispatch, isValid) => () => {
  if (isValid) {
    dispatch(Actions.sendSmsStart());
  }
};


const getButtonText = (status) => {
  switch(status) {
    case statuses.SENDING:
      return 'Sending...';
    case statuses.ERROR:
      return 'Text Failed';
    case statuses.SUCCESS:
      return 'Link Sent!';
    case statuses.INITIAL:
    default:
      return 'Text Me';
  }
};


const phoneIconSvg = (
  <svg width="12px" height="19px" viewBox="0 0 12 19">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-122.000000, -2054.000000)" fill="#9B9B9B">
        <g transform="translate(-71.000000, 1822.000000)">
          <g transform="translate(177.000000, 215.000000)">
            {/* eslint-disable */}
            <path d="M16.585933,35.3 C16.976555,35.6694118 17.4517703,35.8541176 18.0103349,35.8541176 L25.9956938,35.8541176 C26.52689,35.8541176 27.0008612,35.6694118 27.3914833,35.3 C27.7833493,34.9294118 27.9786603,34.4811765 27.9786603,33.9788235 L27.9786603,18.8741176 C27.9786603,18.3729412 27.7833493,17.9235294 27.3914833,17.5541176 C27.0008612,17.1847059 26.52689,17 25.9956938,17 L18.0103349,17 C17.4517703,17 16.976555,17.1847059 16.585933,17.5541176 C16.195311,17.9235294 16,18.3729412 16,18.8741176 L16,33.9788235 C16,34.4811765 16.195311,34.9294118 16.585933,35.3 L16.585933,35.3 Z M17.5077512,21.2517647 C17.5077512,21.1188235 17.5637321,21.0129412 17.6470813,20.9082353 C17.7590431,20.8282353 17.8710048,20.7752941 18.0103349,20.7752941 L25.9683254,20.7752941 C26.1076555,20.7752941 26.2196172,20.8282353 26.3315789,20.9082353 C26.4149282,21.0129412 26.4709091,21.1188235 26.4709091,21.2517647 L26.4709091,31.6023529 C26.4709091,31.7341176 26.4149282,31.84 26.3315789,31.9458824 C26.2196172,32.0247059 26.1076555,32.0776471 25.9683254,32.0776471 L18.0103349,32.0776471 C17.8710048,32.0776471 17.7590431,32.0247059 17.6470813,31.9458824 C17.5637321,31.84 17.5077512,31.7341176 17.5077512,31.6023529 L17.5077512,21.2517647 L17.5077512,21.2517647 Z M20.747177,18.8741176 L23.2314833,18.8741176 C23.3994258,18.8741176 23.4827751,18.9541176 23.4827751,19.1117647 C23.4827751,19.2705882 23.3994258,19.3494118 23.2314833,19.3494118 L20.747177,19.3494118 C20.5792344,19.3494118 20.4946411,19.2705882 20.4946411,19.1117647 C20.4946411,18.9541176 20.5792344,18.8741176 20.747177,18.8741176 L20.747177,18.8741176 Z M21.9750239,32.7905882 C22.3382775,32.7905882 22.6169378,32.8964706 22.8682297,33.1341176 C23.1195215,33.3717647 23.2314833,33.6352941 23.2314833,33.9529412 C23.2314833,34.2964706 23.1195215,34.56 22.8682297,34.7976471 C22.6169378,35.0352941 22.3382775,35.1411765 21.9750239,35.1411765 C21.6403828,35.1411765 21.3604785,35.0352941 21.1091866,34.7976471 C20.8578947,34.56 20.747177,34.2964706 20.747177,33.9529412 C20.747177,33.6352941 20.8578947,33.3717647 21.1091866,33.1341176 C21.3604785,32.8964706 21.6403828,32.7905882 21.9750239,32.7905882 L21.9750239,32.7905882 Z" id="Fill-159-Copy"></path>
            {/* eslint-enable */}
          </g>
        </g>
      </g>
    </g>
  </svg>
);


export default ({ model: { inputValue, status }, dispatch, staticRender }) => {
  const isValid = validatePhoneNumber(inputValue);
  return (
    <div className={getContainerClasses(staticRender)}>
      <div className={classes.inputContainer}>
        <span className={classes.phoneIcon}>
          {phoneIconSvg}
        </span>
        <input className={getPhoneNumberClass(inputValue, status, isValid)}
          type="text"
          onKeyUp={onInputKeyUp(dispatch, isValid)}
          disabled={getInputDisabled(status, staticRender)}
          placeholder="(###) ### - ####"
        />
      </div>
      <div className={classes.buttonContainer}>
        <button className={`btn btn-primary ${classes.getLinkButton}`}
          onClick={onButtonClick(dispatch, isValid)}
          disabled={getButtonDisabled(inputValue, status, isValid)}
        >
          {getButtonText(status)}
        </button>
      </div>
    </div>
  );
};



/** WEBPACK FOOTER **
 ** ./shared-components/TextAppForm/component.js
 **/